export default {
  name: 'marking--releaseMethodType',
};